import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const SITE_VIDEO_REPORT_ID = `site${VIDEO_CAMPAIGN_SUFFIX}`;
